import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Tab,
  Tooltip,
  Typography,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

import apis from "../../apis";
import { handleCallApiError } from "../../errors";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import tabs from "./config";
import { StyledCustomerDetail } from "./index.style";

const CustomerDetail = () => {
  const history = useHistory();
  const { customerId } = useParams();

  const [customer, setCustomer] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [value, setValue] = React.useState("2");

  const fetchCustomer = async () => {
    setLoading(true);
    try {
      const res = await apis.customer.getCustomer(customerId);
      setCustomer(res.customer);
    } catch (error) {
      handleCallApiError(error);
      setError(true);
    }
    setLoading(false);
  };

  const handleGoBack = () => history.goBack();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchCustomer();
  }, []);

  if (loading)
    return (
      <Box padding={2}>
        <CircularProgress />
      </Box>
    );

  if (error)
    return (
      <Box padding={2}>
        <Tooltip title="Quay lại">
          <IconButton onClick={handleGoBack} size="large">
            <ArrowBack fontSize="inherit" />
          </IconButton>
        </Tooltip>
        <Typography variant="body1" textAlign="center">
          Không tìm thấy khách hàng !
        </Typography>
      </Box>
    );

  return (
    <StyledCustomerDetail>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
        mb={1}
      >
        <Tooltip title="Quay lại">
          <IconButton onClick={handleGoBack} size="large">
            <ArrowBack fontSize="inherit" />
          </IconButton>
        </Tooltip>

        <Typography variant="h5" marginBottom={1} fontSize="22px">
          {customer.name} - {customer.phoneNumber}
        </Typography>
      </Stack>
      <TabContext value={value}>
        <Box className="nav-tabs">
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="lab API tabs example"
          >
            {tabs.map((tab) => (
              <Tab
                label={tab.name.toUpperCase()}
                value={tab.value}
                key={tab.value}
                className="tab selected-tab"
              />
            ))}
          </TabList>
        </Box>
        {tabs.map(({ component: Component, value }) => (
          <TabPanel key={value} value={value} className="tab-panel">
            <Component
              customer={customer}
              fetchCustomer={fetchCustomer}
              customerId={customerId}
            />
          </TabPanel>
        ))}
      </TabContext>
    </StyledCustomerDetail>
  );
};

export default CustomerDetail;
